import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { ALL_COMPANIES_OPTION } from 'utils/partnerUtils'

import {
  selectCompanySelectorObject,
  selectPartner,
  selectSortedCompaniesOptions,
} from 'containers/App/selectors'
import { applyCompanyFilter, companyFilterChange } from 'containers/PartnerOptions/actions'
import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'

import Select from 'components/lib/DesignSystem/Select'

const CompanySelectorGuard = ({ partner, ...props }) =>
  partner ? <CompanySelector {...props} /> : null

const CompanySelector = ({
  className,
  companyFilter,
  companySelector,
  companies,
  showAllCompaniesOption,
  optionsFilter,
  style,
  labelText = 'Companies',
  getPopupContainer,
  applyCompanyFilter: applyCompanyFilterHandler, // Have to rename otherwise we have conflict with the import
  companyFilterChange: companyFilterChangeHandler, // same,
}) => {
  const [partnerCompanies, setPartnerCompanies] = useState(companies)

  useEffect(() => {
    if (showAllCompaniesOption && !partnerCompanies.includes(ALL_COMPANIES_OPTION)) {
      setPartnerCompanies((prev) => [ALL_COMPANIES_OPTION, ...prev])
    }

    if (!showAllCompaniesOption && partnerCompanies.includes(ALL_COMPANIES_OPTION)) {
      setPartnerCompanies((prev) => prev.filter((company) => company.value !== ''))
    }
  }, [])

  useEffect(() => {
    if (!companyFilter || companyFilter.value === ALL_COMPANIES_OPTION.value)
      applyCompanyFilterHandler(companySelector)
  }, [companyFilter, applyCompanyFilterHandler, companySelector])

  const handleChangeCompanyFilter = (value, option) => {
    companyFilterChangeHandler({
      value: option.data.value,
      label: option.data.label,
    })
  }

  // Callers may narrow the list to companies their feature can act on. The current
  // selection always survives, or the control renders a value absent from its own menu.
  const visibleCompanies = optionsFilter
    ? partnerCompanies.filter(
        (company) => optionsFilter(company) || company.value === companyFilter?.value
      )
    : partnerCompanies

  return (
    <Select
      labelText={labelText}
      id="companies_select"
      value={companyFilter?.value}
      onSelect={(value, option) => handleChangeCompanyFilter(value, option)}
      options={visibleCompanies}
      // Options carry {value: companyId, label: companyName}, and the Select filters on
      // optionFilterProp, which defaults to "value" -- so typing a company name searched
      // the numeric ids and matched nothing.
      optionFilterProp="label"
      clearable={false}
      className={className}
      style={style}
      width={220}
      getPopupContainer={getPopupContainer}
    />
  )
}

export default connect(
  (state) => ({
    partner: selectPartner(state),
    companyFilter: selectCompanyFilter(state),
    companySelector: selectCompanySelectorObject(state),
    companies: selectSortedCompaniesOptions(state),
  }),
  (dispatch) => bindActionCreators({ applyCompanyFilter, companyFilterChange }, dispatch)
)(CompanySelectorGuard)
